export default "__VITE_ASSET__Bfvave8s__"